// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___1Q8vI","customViewBtn":"styles-module__customViewBtn___3ztIe","callBtnDiv":"styles-module__callBtnDiv___3abmR"};